
export default (props) => {
    

    return (

        <textarea defaultValue="" onChange={props.onChange} />
    );
}

